import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {AndroidIcon, IphoneIcon, BackendIcon, CPAppIcon} from "../../../app-constants";
import {Link} from 'gatsby';

const StackItem = [
    {
        icon: IphoneIcon,
        title: 'iOS App Development',
        description: 'SwiftLint, Objective-C, RxSwift, CircleCI, Swift, SwiftUI, CocoaPods',
    },
    {
        icon: AndroidIcon,
        title: 'Android App Development',
        description: 'Java, Kotlin, Fastlane, Gradle, Coroutines, Dagger2, JetPack',
    },
    {
        icon: CPAppIcon,
        title: 'Android App Development',
        description: 'TypeScript, React Native, Javascript, Flutter, Native Script.',
    },
    {
        icon: BackendIcon,
        title: 'Cross-Platform App Development',
        description: 'Node.js, Ruby on Rail (RoR), Python, Firebase.',
    }

];


function Technology(props) {
    return (
        <div className="technoloy_sec p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
                        <div className="example" data-text="Tech">
                            <h2>Technologies TekRevol Uses for Mobile App Development</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto offset-xl-1">
                        <p>As a top-notch mobile <Link to='https://maps.app.goo.gl/C736Dx6metVfsa2n6' rel='noopener' aria-label='TekRevol' rel='noopener' target="_blank">app development company in NYC</Link>, we leverage a wide spectrum of powerful technologies, precisely customised to cater to your business needs.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
                        <div className="technology_main">
                            {StackItem.map((item, index) => (
                                <div className="technology_item">
                                    <div className="svg_icon">
                                        {item.icon}
                                    </div>
                                    <h6>{item.title}</h6>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Technology;